import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Fab from '@mui/material/Fab';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Fade from '@mui/material/Fade';
// import Grid from '@mui/material/Grid2';
import { Link, useNavigate } from "react-router-dom";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Tooltip } from '@mui/material';

function ScrollTop(props) {
  const { children, window } = props;

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      '#back-to-top-anchor',
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: 'center',
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 999 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element,
  window: PropTypes.func,
};

export default function Navbar(props) {

  const navigate = useNavigate();

  return (
    <React.Fragment>
      <AppBar color='#FFFFFF66' sx={{ pl: 5, pr: 5, height: 100, borderBottomRightRadius: 30, borderBottomLeftRadius: 30, backgroundColor: '#FFFFFF66', boxShadow: '0px 7px 14.7px 0px #00000040', backdropFilter: 'blur(40.5px)' }}>
        <Toolbar sx={{ height: "100%" }}>
          {/* <Grid container justifyContent="space-between" alignItems="center" width="100%">
            <Grid item size={3}>
              <Box component="img" onClick={() => (window.location.href = '/')} 
            //   src={logo} 
              width={228} height={68} sx={{cursor:"pointer"}}/>
            </Grid>
            </Grid> */}
          <Box
            sx={{
              maxWidth: "70%",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Tooltip title="Back" arrow >
            <IconButton
              onClick={() => navigate(-1)}
              size="small"
              sx={{
                color: "text.primary",
              }} 
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
            </Tooltip>

            <Typography variant="h5">
              Spot My Team – ME Foods
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      <Box id="back-to-top-anchor" />

      <ScrollTop {...props}>
        <Fab size="small" aria-label="scroll back to top">
          <ArrowUpwardIcon />
        </Fab>
      </ScrollTop>

    </React.Fragment>
  );
}
